export default __webpack_public_path__ + "static/bidra-i-figma6-20292969c073982e3f854ba9162db1bb.png";